"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/cy");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Testun amgen:"
  },
  announcement_list_da155734: {
    message: "Rhestr Cyhoeddiadau"
  },
  announcements_a4b8ed4a: {
    message: "Cyhoeddiadau"
  },
  assignments_1e02582c: {
    message: "Aseiniadau"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Lliw''r Cefndir, pwyswch i lawr i ddewis"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Canslo\u2019r broses llwytho ffeil i fyny"
  },
  cancel_image_upload_2c771950: {
    message: "Canslo''r broses llwytho delwedd i fyny"
  },
  cc_attribution_f6de631f: {
    message: "CC Attribution"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC Attribution No Derivatives"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC Attribution Non-Commercial"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC Attribution Non-Commercial No Derivatives"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC Attribution Non-Commercial Share Alike"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC Attribution Share Alike"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Edrychwch i weld a yw\u2019r ddelwedd yn addurniadol"
  },
  choose_usage_rights_33683854: {
    message: "Dewiswch hawliau defnyddio..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Cliciwch unrhyw ffeil i fewnosod dolen llwytho i lawr ar gyfer y ffeil honno."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Cliciwch unrhyw ddelwedd i blannu\u2019r ddelwedd yn y dudalen."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Cliciwch unrhyw dudalen i fewnosod dolen i\u2019r dudalen honno."
  },
  click_to_embed_image_33107dd8: {
    message: "Cliciwch i blannu delwedd"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Cliciwch i blannu { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Cliciwch i fewnosod dolen i\u2019r nodwedd golygu."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Cliciwch i fewnosod dolen i\u2019r eitem hon."
  },
  close_flickr_form_b32e600a: {
    message: "Cau\u2019r ffurflen Flickr"
  },
  collaborations_5c56c15f: {
    message: "Cydweithrediadau"
  },
  copyright_holder_66ee111: {
    message: "Perchennog yr Hawlfraint:"
  },
  course_navigation_dd035109: {
    message: "Crwydro\u2019r Cwrs"
  },
  creative_commons_license_725584ae: {
    message: "Trwydded Creative Commons:"
  },
  decorative_image_fde98579: {
    message: "Delwedd addurniadol"
  },
  discussions_a5f96392: {
    message: "Trafodaeth"
  },
  discussions_index_6c36ced: {
    message: "Mynegai Trafodaethau"
  },
  embed_image_1080badc: {
    message: "Plannu Delwedd"
  },
  enter_search_terms_e397b1f0: {
    message: "rhowch y termau chwilio"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Rhowch y testun amgen ar gyfer y ddelwedd hon"
  },
  file_upload_form_4aaad554: {
    message: "Ffurflen llwytho ffeiliau i fyny"
  },
  files_c300e900: {
    message: "Ffeiliau"
  },
  files_index_af7c662b: {
    message: "Mynegai Ffeiliau"
  },
  folder_705fd2d7: {
    message: "Ffolder"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Maint y Ffont, pwyswch i lawr i ddewis"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Fformat, pwyswch i lawr i ddewis"
  },
  grades_a61eba0a: {
    message: "Graddau"
  },
  group_navigation_99f191a: {
    message: "Dewislen Crwydro Grwpiau"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Rydw i wedi cael caniat\xE2d i ddefnyddio\u2019r ffeil hon."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Fi sydd biau\u2019r hawlfraint"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Os na fyddwch chi\u2019n dewis hawliau defnyddio yn awr, bydd y ffeil hon yn cael ei dad-gyhoeddi ar \xF4l iddi gael ei llwytho i fyny."
  },
  image_upload_form_7b74079a: {
    message: "Ffurflen llwytho delweddau i fyny"
  },
  images_7ce26570: {
    message: "Delweddau"
  },
  insert_equella_links_49a8dacd: {
    message: "Mewnosod Dolenni EQUELLA"
  },
  insert_link_6dc23cae: {
    message: "Mewnosod Dolen"
  },
  insert_math_equation_57c6e767: {
    message: "Mewnosod hafaliad mathemategol"
  },
  link_7262adec: {
    message: "Dolen"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Cysylltwch \xE2 Thudalen Newydd"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Cysylltwch \xE2 chynnwys arall ar y cwrs."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Cysylltwch \xE2 chynnwys arall yn y gr\u0175p."
  },
  link_to_url_52dd935c: {
    message: "Dolen i\u2019r URL"
  },
  links_14b70841: {
    message: "Dolenni"
  },
  load_more_results_460f49a9: {
    message: "Llwytho mwy o ganlyniadau"
  },
  loading_25990131: {
    message: "Wrthi\u2019n llwytho..."
  },
  loading_failed_b3524381: {
    message: "Wedi methu llwytho..."
  },
  loading_folders_8d4d5d5a: {
    message: "Wrthi\u2019n llwytho ffolderi..."
  },
  modules_c4325335: {
    message: "Modiwlau"
  },
  no_results_940393cf: {
    message: "Dim canlyniadau."
  },
  pages_e5414c2c: {
    message: "Tudalennau"
  },
  people_b4ebb13c: {
    message: "Pobl"
  },
  quizzes_7e598f57: {
    message: "Cwisiau"
  },
  record_upload_media_5fdce166: {
    message: "Recordio Cyfryngau/Llwytho Cyfryngau i Fyny"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Ardal Testun Cyfoethog. Pwyswch ALT+F8 i gael help"
  },
  search_280d00bd: {
    message: "Chwilio"
  },
  search_flickr_6884b518: {
    message: "Chwilio Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Dewiswch ffeil"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Dewiswch ffolder i lwytho eich ffeil i fyny iddi"
  },
  syllabus_f191f65b: {
    message: "Maes Llafur"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Lliw''r Testun, pwyswch i lawr i ddewis"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Mae\u2019r deunydd yn y parth cyhoeddus"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Mae\u2019r deunydd wedi''i drwyddedu o dan Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Mae\u2019r eithriad defnydd teg yn berthnasol i''r deunydd"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Mae\u2019r ffeiliau a lwythwyd i fyny yn fwy na\u2019r cwota storio ffeiliau. Siaradwch \xE2\u2019ch gweinyddwr system."
  },
  upload_8b403d05: {
    message: "Llwytho i fyny"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Llwythwch ffeil newydd i fyny"
  },
  upload_a_new_image_890df275: {
    message: "Llwythwch ddelwedd newydd i fyny"
  },
  usage_right_ff96f3e2: {
    message: "Hawl Defnyddio:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Beth hoffech chi alw\u2019r dudalen newydd?"
  },
  wiki_home_9cd54d0: {
    message: "Hafan Wici"
  }
};

_formatMessage.default.addLocale({
  cy: locale
});